import {IComponentOptions, ILogService} from "angular";
import "./course-offer-status.less";
import {ApplicationService} from "../application.service";
import {Application} from "../../model/Application";

class CourseOfferStatusController {

    private application: Application;
    private courseOfferStatus: any;
    private courseOfferRefreshInProgress: boolean;

    /* @ngInject */
    constructor(private $log: ILogService,
                private applicationService: ApplicationService,
                private toaster: any) {
    }

    private refreshCourseOfferStatus() {
        this.$log.debug("refreshCourseOfferStatus");
        this.courseOfferRefreshInProgress = true;
        this.applicationService.getCourseOfferStatusByApplicationId(this.application.id)
            .then((latestCourseOfferStatus) => {
                this.courseOfferStatus = latestCourseOfferStatus;
            }).catch((error) => {
                this.toaster.pop({type: "failure", title: "Could not refresh course offer status"});
                this.$log.warn("Failed to refresh course offer status: %s", error);
            }).finally(() => {
                this.courseOfferRefreshInProgress = false;
            });
    }
}

export const CourseOfferStatusComponent: IComponentOptions = {
    bindings: {
        application: "<",
        courseOfferStatus: "<"
    },
    controller: CourseOfferStatusController,
    template: require("./course-offer-status.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/course-offer-status/course-offer-status.component.ts